<script setup lang="ts">
import {h, ref, reactive, watch, computed, onMounted} from 'vue';
import {useRouter} from "vue-router";
const current = ref<string[]>(['1']);
import {
  SlackOutlined, MenuFoldOutlined, MenuUnfoldOutlined,
  AppstoreOutlined, UserOutlined
} from '@ant-design/icons-vue';


const router = useRouter()
const state = reactive({
  collapsed: false,
  selectedKeys: ['1'],
  openKeys: ['sub1'],
  preOpenKeys: ['sub1'],
});

onMounted(()=>{
  console.log("进入nav-->")
})

const menus = ref<any[]>([
  {key: '1', label: '股票管理', title: '股票管理',
    children: [
      {key: '10', label: '股票列表', title: '股票列表',path: '/stock', icon: () => h(SlackOutlined)},
      {key: '11', label: '板块分析', title: '板块分析',path: '/industry', icon: () => h(SlackOutlined)},
      {key: '12', label: '财务数据', title: '财务数据',path: '/financial', icon: () => h(SlackOutlined)},
      {key: '13', label: '币列表', title: '币列表', path: '/symbol', icon: () => h(SlackOutlined)},
    ],
    icon: () => h(AppstoreOutlined),
  },
])

const headerMenus = computed(()=>{
  return menus.value?.map(item=>{
    return {...item, children: null}
  })
})

const leftMenus = computed(()=>{
  return menus.value?.find(item=>item.key===current.value[0]).children
})

const clickMenu = ({item}: {item: any}) =>{
  if(item.path){
    router.push(item.path)
  }
}

watch(
    () => state.openKeys,
    (_val, oldVal) => {
      state.preOpenKeys = oldVal;
    },
);

</script>

<template>
  <div class="header">
    <div>
      <div class="logo">
        <img src="/logo.svg" height="30" width="30" style="margin-right: 5px">
        量化系统
      </div>
    </div>
    <div>
      <a-menu v-model:selectedKeys="current" mode="horizontal" :items="headerMenus" />
    </div>
    <div class="header-right">
      <UserOutlined />
      <div style="margin-left: 10px">杨茂奇</div>
    </div>
  </div>
  <a-layout>
    <a-layout-sider v-model:collapsed="state.collapsed" :trigger="null" collapsible>
      <a-menu
          v-model:openKeys="state.openKeys"
          v-model:selectedKeys="state.selectedKeys"
          mode="inline"
          :inline-collapsed="state.collapsed"
          :items="leftMenus"
          @click="clickMenu"
      ></a-menu>
      <div @click="state.collapsed = !state.collapsed" class="sider-collapsed">
        <a >
          <MenuFoldOutlined v-if="!state.collapsed"  />
          <MenuUnfoldOutlined v-else />
        </a>
      </div>

    </a-layout-sider>
    <a-layout-content
        :style="{ margin: '16px', padding: '24px', background: '#fff', minHeight: '280px' }"
    >
      <router-view></router-view>
    </a-layout-content>
  </a-layout>
</template>

<style scoped>
.sider-collapsed{
  position: absolute;
  bottom: 0;
  width: 100%;
  height:50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  border-top: 1px solid #e8e6e6;
}
.sider-collapsed:hover{
  background-color: #e6f4ff;
  cursor: pointer;
}
</style>